import React, { createElement } from 'react';

import DataDrivenLogo from '../../../../components/data-driven-logo';
import { Drawer } from 'ui-components/components/drawer/drawer';
import { DrawerHeader } from 'ui-components/components/drawer/drawer-header';
import { useStepDetectiveContext } from '../../../../components/csv-import/ui/components/step-detective/step-detective-context';
import { useEntitiesSalesOrder } from '../../../../hooks/entities/selectors/sales-orders';

import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';

import style from './create-enhanced-return-drawer.module.less';

const CREATE_STEP_INDEX = 0;

/**
 * @param {object} props
 * @param {() => void} props.onClose
 * @param {string} props.salesOrderId
 * @param {string} [props.requestId]
 * @returns {JSX.Element}
 */
export const CreateEnhancedReturnDrawer = ({ onClose, requestId, salesOrderId }) => {
  const salesOrder = useEntitiesSalesOrder(salesOrderId) ?? {};
  const { activeStep, activeStepIndex } = useStepDetectiveContext();
  const modalTitle = activeStepIndex === CREATE_STEP_INDEX ? messages.modalTitleCreate : messages.modalTitleConfigure;

  return (
    <Drawer className={style['drawer-level-two']} onCancel={onClose} onClose={onClose}>
      <DrawerHeader
        closeButtonAriaLabel={messages.closeDrawerButtonAriaLabel}
        title={
          <>
            <DataDrivenLogo className={style['marketplace-icon']} logoType='icon' marketplaceId={salesOrder?.store?.marketplaceId} />
            <Text className={style['drawer-header']} textType={TextType.H4} value={modalTitle} />
          </>
        }
      />
      <div className={style['drawer-content']}>
        {createElement(activeStep.body.type, {
          ...activeStep.body.props,
          requestId,
        })}
      </div>
      <div className={style['drawer-footer']}>
        {createElement(activeStep.footer.type, {
          ...activeStep.footer.props,
          onCancel: onClose,
        })}
      </div>
    </Drawer>
  );
};
